import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  defineList: "/xxy/abnormal/list",
  abnormalList: "/xxy/abnormal/getInfo",
  saveAbnormal: "/xxy/abnormal/save",
  removeAbnormal: "/xxy/abnormal/remove",
  batchRemoveAbnormal: "/xxy/abnormal/batchRemove",

  saveCall: "/xxy/abnormal/order/save",
  toResponse: "/xxy/abnormal/order/response",
  toHandle: "/xxy/abnormal/order/handle",
  callList: "/xxy/abnormal/order/list",

  typeList: "/xxy/abnormal/type/list",
  allTypeList: "/xxy/abnormal/type/getInfo",
  saveType: "/xxy/abnormal/type/save",
  removeType: "/xxy/abnormal/type/remove",
  batchRemoveType: "/xxy/abnormal/type/batchRemove",
  AbnormalTypeList: "/xxy/abnormal/type/listAbnormalType",

  resultList: "/xxy/abnormal/order/reslist",

  userList: "/uaa/user/list",
  devList: "/xxy/basic/device/getInfo"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}
/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
